module.exports = __webpack_public_path__ + "assets/person-add-0e26d0c0a71ef98d3f02cf0ad84a6286.svg";